<template>
  <div class="authWrapper new-login-wrapper">
    <div class="container">
      <div class="row whiteBG-wrap login-white-wrap">
        <div class="col-lg-7 col-md-7 no-padding">
          <div class="login-left-wrap">
            <button @click="goBack"  class="text-link"> Back</button>
            <div class="rep-icon-login">
              <img
                  src="../../assets/images/member-login.svg"
                  alt="image-fluid"
              />
            </div>
            <h4 class="login-title mb-2">Verify it's you</h4>
            <form @submit.prevent="submit">
              <input-form-text
                :rules="{ required: true, email: true }"
                :customMessages="`Please enter your email address.`"
                :customEmailMessage="`Please enter a valid email address`"
                labelFor="Email"
                labelName="Email"
                inputName="email"
                formGroupClass="form-group mb-3"
                 @emitChanges="resetErrorMsg"
                placeholder="Please enter your email address"
                 :isErrorFlagSet="emailErrorFlag"
                :vmodel.sync="form.email"
                :disabled="true"
              />
              <input-form-text
                :rules="{ required: true,  }"
                :customMessages="`Please enter your phone number.`"
                labelFor="Phone"
                labelName="Phone"
                inputName="phone"
                formGroupClass="form-group mb-3"
                placeholder="Please enter your phone number"
                 :isErrorFlagSet="phoneErrorFlag"
                 @emitChanges="resetErrorMsg"
                :vmodel.sync="form.phone"
                :disabled="true"
              />
              <div class="submit-btn-wrap" >
                <button
                  :disabled="formLoader"
                  class="submit-btn mt-1 next-btn w-100 ml-0 "
                  type="button"
                  @click="submit"
                >
                  <b-spinner v-if="formLoader" small class="mr-3"></b-spinner>
                  Send Verification
                </button>
              </div>
            </form>
            <!-- <submit-issue /> -->
          </div>
        </div>
        <div class="col-lg-5 col-md-5 no-padding p-0">
          <Logincarsoule />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Logincarsoule from "./Logincarsoule";
// import SubmitIssue from "./SubmitIssue";
import Helper from "@/resource/Helper";
import InputFormText from "../../components/form/InputFormText.vue";
import Api from "@/resource/MemberApi";
export default {
  name: "VerificationDetail",

  components: {
    Logincarsoule,
    // SubmitIssue,
    InputFormText
  },
   data: () => {
    return {
      form: {
        phone: "",
        email: "",
        userid: "",
      },
      emailErrorFlag:false,
      phoneErrorFlag:false,
      errors: {},
      formLoader: false
    };
  },
  methods: {
    goBack() {
      this.$store.commit("setMemberEmail", "");
      this.$store.commit("setMemberId", "");
      this.$store.commit("setMemberPhone", "");
      this.$router.push({ name: "NewSignup" });
    },
    setData() {
      this.form.userid = this.$store.state.memberId;
      this.form.phone = this.$store.state.memberPhone;
      this.form.email = this.$store.state.memberEmail;
      if (!this.form.phone || !this.form.email) {
        this.$router.push({ name: "NewSignUp" });
      }
    },
    submit() {
      this.formLoader = true;
      let url = "v2/auth/validate-registration-email-phone";
      Api
        .post(url, this.form)
        .then((res) => {
          this.$store.commit("setOtpSend", true);
          this.$store.commit("setMemberPhone", this.form.phone);
          this.$store.commit("setMemberEmail", this.form.email);
          Helper.infoMessage(this, res.data.status, res.data.message);
          this.$router.push({ name: "RegisterOTP" });
        })
        .catch((err) => {
          Helper.infoMessage(
            this,
            err.response.data.status,
            err.response.data.message
          );
          this.emailErrorFlag=true,
          this.phoneErrorFlag=true
        }).finally(()=> {
          this.formLoader = false;
        });
    },
    resetErrorMsg(){
      this.errors=false,
      this.emailErrorFlag=false,
      this.phoneErrorFlag=false
    }
  },
  created() {
    this.setData();
  },
};
</script>
<style src="@/assets/css/authen.css"></style>
<style src="@/assets/css/newLogin.css"></style>

<style>
#label-username,
#label-password {
  font-size: 16px !important;
  color: #909090 !important;
  margin-bottom: 10px !important;
}
#username,
#password {
  font-size: 14px !important;
  padding: 12px 15px !important;
}
.rep-icon-login {
  width: 80px;
}
/* .rep-icon-login img {
  width: 100px;
} */
</style>

<style scoped> 
.submit-btn{
  border: none;
}
.submit-btn:active{
  border: none;
}
.text-link{
  border: none;
  background: transparent;
}
</style>
  
    